import { IActivityDefinition } from '../resources/activities/activity_definition';
import { IActivity } from '../resources/activities/activity';
import { ActivityDefinition, ActivityDefinitionParams } from './activity_definition';
import { Versions } from '../constants/versions';

export interface ActivityParams {
	objectType?: string;
	id?: string;
	definition?: IActivityDefinition;
	[key: string]: any;
}

export class Activity {
	objectType = 'Activity';
	id?: string;
	definition?: ActivityDefinition;

	constructor(cfg: ActivityParams = { objectType: 'Activity' }) {
		if (cfg.definition) {
			if (cfg.definition instanceof ActivityDefinition) {
				this.definition = cfg.definition;
			} else {
				this.definition = new ActivityDefinition(cfg.definition as ActivityDefinitionParams);
			}
		}

		this.id = cfg.id;
	}

	toString(lang: string = 'en-US'): string {
		let defString = '';

		if (this.definition) {
			defString = this.definition.toString(lang);
			if (defString !== '') {
				return defString;
			}
		}

		if (this.id) {
			return this.id;
		}

		return 'Activity: unidentified';
	}

	asVersion(version: Versions = '1.0.3'): IActivity {
		const result: IActivity = {
			id: this.id as string,
			objectType: this.objectType
		};

		if (this.definition) {
			result.definition = this.definition.asVersion(version) as any;
		}

		return result;
	}

	static fromJSON(activityJSON: string): Activity {
		const _activity = JSON.parse(activityJSON);

		return new Activity(_activity);
	}
}
